<script setup lang="ts">
  import { computed, onBeforeUnmount, onMounted, ref } from "vue";
  import { useRoute } from "vue-router";
  import honoraryCertificate1Enlarge from "~/assets/images/about/honorary-certificate/honorary-certificate1-enlarge.png";
  import honoraryCertificate1 from "~/assets/images/about/honorary-certificate/honorary-certificate1.png";
  import honoraryCertificate2Enlarge from "~/assets/images/about/honorary-certificate/honorary-certificate2-enlarge.png";
  import honoraryCertificate2 from "~/assets/images/about/honorary-certificate/honorary-certificate2.png";
  import honoraryCertificate3Enlarge from "~/assets/images/about/honorary-certificate/honorary-certificate3-enlarge.png";
  import honoraryCertificate3 from "~/assets/images/about/honorary-certificate/honorary-certificate3.png";
  import honoraryCertificate4Enlarge from "~/assets/images/about/honorary-certificate/honorary-certificate4-enlarge.png";
  import honoraryCertificate4 from "~/assets/images/about/honorary-certificate/honorary-certificate4.png";
  import memberUnit1Enlarge from "~/assets/images/about/member-unit/member-unit1-enlarge.png";
  import memberUnit1 from "~/assets/images/about/member-unit/member-unit1.png";
  import memberUnit2Enlarge from "~/assets/images/about/member-unit/member-unit2-enlarge.png";
  import memberUnit2 from "~/assets/images/about/member-unit/member-unit2.png";
  import memberUnit3Enlarge from "~/assets/images/about/member-unit/member-unit3-enlarge.png";
  import memberUnit3 from "~/assets/images/about/member-unit/member-unit3.png";
  import memberUnit4Enlarge from "~/assets/images/about/member-unit/member-unit4-enlarge.png";
  import memberUnit4 from "~/assets/images/about/member-unit/member-unit4.png";
  import patentCertificate1Enlarge from "~/assets/images/about/patent-certificate/patent-certificate1-enlarge.png";
  import patentCertificate1 from "~/assets/images/about/patent-certificate/patent-certificate1.png";
  import patentCertificate2Enlarge from "~/assets/images/about/patent-certificate/patent-certificate2-enlarge.png";
  import patentCertificate2 from "~/assets/images/about/patent-certificate/patent-certificate2.png";
  import patentCertificate3Enlarge from "~/assets/images/about/patent-certificate/patent-certificate3-enlarge.png";
  import patentCertificate3 from "~/assets/images/about/patent-certificate/patent-certificate3.png";
  import patentCertificate4Enlarge from "~/assets/images/about/patent-certificate/patent-certificate4-enlarge.png";
  import patentCertificate4 from "~/assets/images/about/patent-certificate/patent-certificate4.png";
  import patentCertificate5Enlarge from "~/assets/images/about/patent-certificate/patent-certificate5-enlarge.png";
  import patentCertificate5 from "~/assets/images/about/patent-certificate/patent-certificate5.png";
  // import BaiduMap from "~/components/BaiduMap.client.vue";
  import { DATA_URL, DLS_URL } from "~/env";
  import listener from "~/utils/listener";

  // import loadBaiduMap from "~/utils/loadBaiduMap";

  definePageMeta({
    layout: "nav-layout",
  });

  useHead({
    titleTemplate: "关于得理 - %s",
  });

  interface Certificate {
    text: string;
    imgUrl: string;
    enlargeImgUrl: string;
  }

  // const mapLoaded = ref(false);
  // const center = ref<{ lng: number; lat: number }>({ lng: 113.951363, lat: 22.537122 });
  // const zoom = ref<number>(17);

  onMounted(async () => {
    const type = route.query.type as string;

    // try {
    //   await loadBaiduMap();
    //   mapLoaded.value = true;
    // } catch (error) {
    //   console.error("百度地图加载失败:", error);
    // }

    setTimeout(() => {
      onPosition(type);
    }, 200);

    api.site();
    listener.on("onAboutPosition", onPosition);
  });

  const introduction = ref<HTMLElement | null>(null);
  const honorRef = ref();
  const origin = ref<HTMLElement | null>(null);

  const api = useApi();

  const patentCertificate = ref<Certificate[]>([
    {
      text: "专利证书——一种逐句段对比的相似文本查找方法及装置",
      imgUrl: patentCertificate1,
      enlargeImgUrl: patentCertificate1Enlarge,
    },
    {
      text: "专利证书——一种基于深度学习的无监督文本检索方法",
      imgUrl: patentCertificate2,
      enlargeImgUrl: patentCertificate2Enlarge,
    },
    {
      text: "专利证书——文本的查询方法、文本查询装置以及计算机存储介质",
      imgUrl: patentCertificate3,
      enlargeImgUrl: patentCertificate3Enlarge,
    },
    {
      text: "专利证书——问答模型的训练方法、计算机设备以及可度存储介质",
      imgUrl: patentCertificate4,
      enlargeImgUrl: patentCertificate4Enlarge,
    },
    {
      text: "专利证书——一种基于深度学习的长文本检索系统及方法",
      imgUrl: patentCertificate5,
      enlargeImgUrl: patentCertificate5Enlarge,
    },
  ]);

  const honoraryCertificate = ref<Certificate[]>([
    {
      text: "深港澳科创新锐企业50强",
      imgUrl: honoraryCertificate1,
      enlargeImgUrl: honoraryCertificate1Enlarge,
    },
    {
      text: "第二十一届中国国际高新技术成果交易会优秀产品奖",
      imgUrl: honoraryCertificate2,
      enlargeImgUrl: honoraryCertificate2Enlarge,
    },
    {
      text: "第二十二届中国国际高新技术成果交易会优秀产品奖",
      imgUrl: honoraryCertificate3,
      enlargeImgUrl: honoraryCertificate3Enlarge,
    },
    {
      text: "第二十三届中国国际高新技术成果交易会优秀产品奖",
      imgUrl: honoraryCertificate4,
      enlargeImgUrl: honoraryCertificate4Enlarge,
    },
  ]);

  const memberUnit = ref<Certificate[]>([
    {
      text: "国家级高新技术企业认定",
      imgUrl: memberUnit1,
      enlargeImgUrl: memberUnit1Enlarge,
    },
    {
      text: "深圳市人工智能学会会员单位",
      imgUrl: memberUnit2,
      enlargeImgUrl: memberUnit2Enlarge,
    },
    {
      text: "深圳市互联网创业创新服务促进会会员单位",
      imgUrl: memberUnit3,
      enlargeImgUrl: memberUnit3Enlarge,
    },
    {
      text: "第五届全国青年人工智能创新创业大会创新组一等奖",
      imgUrl: memberUnit4,
      enlargeImgUrl: memberUnit4Enlarge,
    },
  ]);

  const pictureList = computed<Certificate[]>(() => {
    return [...patentCertificate.value, ...honoraryCertificate.value];
  });

  const onPosition = (type?: string): void => {
    if (type) {
      const refMap: Record<string, HTMLElement | null> = {
        introduction: introduction.value,
        honor: honorRef.value,
        origin: origin.value,
      };

      refMap[type]?.scrollIntoView({
        behavior: "smooth",
        block: "end",
      });
    }
  };

  const onGotoProduct = (type: string): void => {
    switch (type) {
      case "ai":
        window.open("/ai", "_blank");
        break;
      case "data":
        window.open(DATA_URL, "_blank");
        break;
      case "dls":
        window.open(DLS_URL, "_blank");
        break;
    }
  };

  const route = useRoute();

  onBeforeUnmount(() => {
    listener.off("onAboutPosition", onPosition);
  });
</script>

<template>
  <div class="container">
    <div class="banner">
      <div class="title-wrap">
        <h3>- 得理科技 -</h3>
        <h1>法律大模型驱动的 </h1>
        <h1>AI+律师 平台服务商</h1>
      </div>
    </div>
    <div ref="introduction" class="introduction">
      <div class="content">
        <h1 class="tip">公司简介</h1>
        <div class="box">
          <img src="~/assets/images/logo.svg" />
          <div class="text">
            <h2>得理科技有限公司</h2>
            <p>
              深圳得理科技有限公司成立于2018年，是一家由国内顶级法律团队和 AI
              团队联合发起的法律科技公司，并于2019年联手中科院深圳先进院成立法律人工智能实验室，专注法律行业AI模型算法研究。
            </p>
            <p>
              其自研的法律行业AI大模型达到业内领先水平，以得理法律AI大模型为基础，得理科技还研发了得理律助和得理法搜两条主要产品线，以小理AI和小理智能体为核心组件，为法律人、企业及个人提供一揽子法律+AI解决方案。
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="founder">
      <h1 class="tip tw-text-center tw-text-[40px] tw-font-[600] tw-leading-[47px] tw-text-[#1F1F1F]">
        联合创始人团队
      </h1>
      <div class="box">
        <div class="founder-item">
          <img src="~/assets/images/about/founder/member1.png" alt="" />
          <div class="title">
            <span class="name">杨敏</span>
            <span class="profession">首席科学家、联合创始人</span>
          </div>
          <div class="info">
            <div class="info-item tw-flex">
              <div class="tw-mr-[10px] tw-flex tw-h-[34px] tw-w-fit tw-items-center">
                <div class="tw-rounded-[50%] tw-bg-[rgba(53,85,254,0.27)] tw-wh-[12px]"></div>
              </div>
              <div class="intro tw-text-[#5A5D66]">香港大学计算机博士</div>
            </div>
            <div class="info-item tw-flex">
              <div class="tw-mr-[10px] tw-flex tw-h-[34px] tw-w-fit tw-items-center">
                <div class="tw-rounded-[50%] tw-bg-[rgba(53,85,254,0.27)] tw-wh-[12px]"></div>
              </div>
              <div class="intro tw-text-[#5A5D66]">
                深圳市海外高层次人才，入选斯坦福大学发布的2021全球前2%的顶尖科学家
              </div>
            </div>
          </div>
        </div>
        <div class="founder-item">
          <img src="~/assets/images/about/founder/member2.png" alt="" />
          <div class="title">
            <span class="name">贺倩明</span>
            <span class="profession">联合创始人</span>
          </div>
          <div class="info">
            <div class="info-item tw-flex">
              <div class="tw-mr-[10px] tw-flex tw-h-[34px] tw-w-fit tw-items-center">
                <div class="tw-rounded-[50%] tw-bg-[rgba(53,85,254,0.27)] tw-wh-[12px]"></div>
              </div>
              <div class="intro tw-text-[#5A5D66]">中国政法大学经济法博士</div>
            </div>
            <div class="info-item tw-flex">
              <div class="tw-mr-[10px] tw-flex tw-h-[34px] tw-w-fit tw-items-center">
                <div class="tw-rounded-[50%] tw-bg-[rgba(53,85,254,0.27)] tw-wh-[12px]"></div>
              </div>
              <div class="intro tw-text-[#5A5D66]">香港中文大学EMBA</div>
            </div>
            <div class="info-item tw-flex">
              <div class="tw-mr-[10px] tw-flex tw-h-[34px] tw-w-fit tw-items-center">
                <div class="tw-rounded-[50%] tw-bg-[rgba(53,85,254,0.27)] tw-wh-[12px]"></div>
              </div>
              <div class="intro tw-text-[#5A5D66]">国内知名律所高级合伙人</div>
            </div>
            <div class="info-item tw-flex">
              <div class="tw-mr-[10px] tw-flex tw-h-[34px] tw-w-fit tw-items-center">
                <div class="tw-rounded-[50%] tw-bg-[rgba(53,85,254,0.27)] tw-wh-[12px]"></div>
              </div>
              <div class="intro tw-text-[#5A5D66]">中科院先进院得理法律人工智能实验室副主任</div>
            </div>
          </div>
        </div>
        <div class="founder-item">
          <img src="~/assets/images/about/founder/member3.png" alt="" />
          <div class="title">
            <span class="name">雷宇</span>
            <span class="profession">CTO、联合创始人</span>
          </div>
          <div class="info">
            <div class="info-item tw-flex">
              <div class="tw-mr-[10px] tw-flex tw-h-[34px] tw-w-fit tw-items-center">
                <div class="tw-rounded-[50%] tw-bg-[rgba(53,85,254,0.27)] tw-wh-[12px]"></div>
              </div>
              <div class="intro tw-text-[#5A5D66]">先后任职于百度、腾讯</div>
            </div>
            <div class="info-item tw-flex">
              <div class="tw-mr-[10px] tw-flex tw-h-[34px] tw-w-fit tw-items-center">
                <div class="tw-rounded-[50%] tw-bg-[rgba(53,85,254,0.27)] tw-wh-[12px]"></div>
              </div>
              <div class="intro tw-text-[#5A5D66]">超过10年互联网企业研发管理经验</div>
            </div>
            <div class="info-item tw-flex">
              <div class="tw-mr-[10px] tw-flex tw-h-[34px] tw-w-fit tw-items-center">
                <div class="tw-rounded-[50%] tw-bg-[rgba(53,85,254,0.27)] tw-wh-[12px]"></div>
              </div>
              <div class="intro tw-text-[#5A5D66]">专注于大数据和大模型算法</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div ref="honorRef" class="honor">
      <h1 class="tip">得理荣誉及专利资质</h1>
      <h3>
        截至2024年，公司已拥有15+AI专利技术，得理法律大模型成为首批通过国家网信办备案的生成式算法，公司技术团队累计发表上百篇权威学术论文，收获国际法律AI大赛等多项比赛奖项和行业荣誉，并被认定为“国家高新技术企业”。
      </h3>
      <div class="carousel">
        <a-carousel :dots="false" autoplay arrows>
          <template #prevArrow>
            <div class="prev-arrow">
              <icon-font class="arrow" type="jiantou" />
              <!-- <Icon class="arrow" name="custom:jiantou" />-->
            </div>
          </template>
          <template #nextArrow>
            <div class="next-arrow">
              <icon-font class="arrow" type="fanhui" />
              <!-- <Icon class="arrow" name="custom:fanhui" />-->
            </div>
          </template>
          <div class="patent-certificate">
            <div class="img-wrap">
              <a-tooltip
                v-for="(item, index) in patentCertificate"
                :key="index"
                :get-popup-container="() => honorRef"
                trigger="hover"
                placement="top">
                <template #title>
                  <div class="img-enlarge">
                    <p>{{ item.text }}</p>
                    <img :src="item.enlargeImgUrl" />
                  </div>
                </template>
                <div class="img-item">
                  <img :src="item.imgUrl" />
                </div>
              </a-tooltip>
            </div>
          </div>
          <div class="honorary-certificate">
            <div class="img-wrap">
              <a-tooltip
                v-for="(item, index) in honoraryCertificate"
                :key="index"
                :get-popup-container="() => honorRef"
                trigger="hover"
                placement="top">
                <template #title>
                  <div class="img-enlarge">
                    <p>{{ item.text }}</p>
                    <img :src="item.enlargeImgUrl" />
                  </div>
                </template>
                <div class="img-item">
                  <img :src="item.imgUrl" />
                </div>
              </a-tooltip>
            </div>
          </div>
          <div class="member-unit">
            <div class="img-wrap">
              <a-tooltip
                v-for="(item, index) in memberUnit"
                :key="index"
                :get-popup-container="() => honorRef"
                trigger="hover"
                :align="{
                  points: ['bc', 'tl'],
                  overflow: { adjustX: true, adjustY: true },
                }">
                <template #title>
                  <div class="img-enlarge">
                    <p>{{ item.text }}</p>
                    <img :src="item.enlargeImgUrl" />
                  </div>
                </template>
                <div class="img-item">
                  <img :src="item.imgUrl" />
                </div>
              </a-tooltip>
            </div>
          </div>
        </a-carousel>
      </div>
      <div class="picture-list">
        <img v-for="(picture, i) in pictureList" :key="i" :src="picture.enlargeImgUrl" alt="" />
      </div>
    </div>
    <div class="develop-history tw-px-[65px] tw-py-[130px] md:tw-px-[0]">
      <h1 class="tip tw-text-center tw-text-[40px] tw-font-[600] tw-leading-[47px] tw-text-[#1F1F1F]">公司发展历程</h1>

      <img class="tw-hidden md:tw-block" src="~/assets/images/about/develop-history/bg.png" alt="" />
      <img class="tw-mt-[70px] md:tw-hidden" src="~/assets/images/about/develop-history/minibg.png" alt="" />
    </div>
    <div ref="origin" class="origin">
      <h1 class="tip">“得理者，知未来”</h1>
      <h4> 公司以“得理”为名，取“得”字之“行有所得”与“理”字“规律”之义，欲将人类智慧与机 </h4>
      <h4>器智慧相结合，继以参透法律之理。</h4>
      <div class="content box1">
        <div class="row">
          <div class="item text one">
            <div class="icon-wrap">
              <icon-font type="AIfunengfalv" />
              <!-- <Icon name="custom:aifunengfalv" />-->
            </div>
            <span class="desc">AI赋能法律</span>
          </div>
          <div class="item">
            <img src="~/assets/images/about/origin/legal-value.png" />
          </div>
          <div class="item text three">
            <div class="icon-wrap">
              <icon-font type="rangfalvpuhuiyumin" />
              <!-- <Icon name="custom:rangfalvpuhuiyumin" />-->
            </div>
            <span class="desc">让法律普惠于民</span>
          </div>
        </div>
        <div class="row">
          <div class="item">
            <img src="~/assets/images/about/origin/ai-empowering-law.png" />
          </div>
          <div class="item text five">
            <div class="icon-wrap">
              <icon-font type="jiazhi" />
              <!-- <Icon name="custom:jiazhi" />-->
            </div>
            <span class="desc">守正创新，共享价值</span>
          </div>
          <div class="item">
            <img src="~/assets/images/about/origin/legal-inclusive.png" />
          </div>
        </div>
      </div>
      <div class="content box2 tw-hidden">
        <div class="item text one">
          <div class="icon-wrap">
            <icon-font type="AIfunengfalv" />
            <!-- <Icon name="custom:aifunengfalv" />-->
          </div>
          <span class="desc">AI赋能法律</span>
        </div>
        <div class="item">
          <img src="~/assets/images/about/origin/ai-empowering-law.png" />
        </div>
        <div class="item text three">
          <div class="icon-wrap">
            <icon-font type="rangfalvpuhuiyumin" />
            <!-- <Icon name="custom:rangfalvpuhuiyumin" />-->
          </div>
          <span class="desc">让法律普惠于民</span>
        </div>
        <div class="item">
          <img src="~/assets/images/about/origin/legal-inclusive.png" />
        </div>
        <div class="item">
          <img src="~/assets/images/about/origin/legal-value.png" />
        </div>
        <div class="item text five">
          <div class="icon-wrap">
            <icon-font type="jiazhi" />
            <!-- <Icon name="custom:jiazhi" />-->
          </div>
          <span class="desc">守正创新，共享价值</span>
        </div>
      </div>
    </div>
    <div class="map">
      <div class="address">
        <div class="address-left">
          <h1>联系我们</h1>
          <div class="item">
            <p class="tw-text-[20px] tw-font-[600] tw-text-[#333]">
              <icon-font type="Group2894" />
              <!-- <Icon name="custom:group2894" />-->
              公司地址：
            </p>
            <p class="tw-text-[20px] tw-text-[#333]">
              <span>深圳市 丨 南山区</span> <span>香港中文大学深圳研究院</span>
            </p>
            <p class="tw-text-[20px] tw-text-[#333]">
              <span>深圳市南山区香港中文大学研究院2层201、210、211室</span>
            </p>
          </div>
          <div class="item">
            <p class="tw-text-[20px] tw-font-[600] tw-text-[#333]">
              <icon-font type="Group2895" class="tw-text-[#3555FE]" />
              <!-- <Icon name="custom:group2895" class="tw-text-[#3555FE]" />-->
              咨询热线：
            </p>
            <p class="tw-text-[20px]">
              <span>0755-26907610</span>
            </p>
          </div>
        </div>
        <div class="address-right tw-flex tw-items-center tw-justify-center">
          <!-- <ClientOnly>
            <BaiduMap v-if="mapLoaded" :center="center" :zoom="zoom" />
          </ClientOnly> -->
          <img src="~/assets/images/about/map.png" class="tw-block tw-aspect-[855/427] tw-h-auto tw-w-full" />
        </div>
      </div>
    </div>
    <div class="experience tw-pt-[30px]">
      <div class="label tw-mb-[30px] tw-text-center tw-text-[30px] tw-text-[#fff]">
        请根据实际情况，选择您要体验的产品
      </div>
      <div
        class="tw-mx-auto tw-h-[1px] tw-bg-[linear-gradient(270deg,_rgba(255,255,255,0)_0%,_#FFFFFF_50%,_rgba(255,255,255,0)_100%)]
          2xl:tw-h-[2px]"></div>
      <div class="list">
        <div class="product-item">
          <img src="~/assets/images/about/experience/xl.png" alt="" class="picture" />
          <div class="product-name">小理AI</div>
          <div class="product-intro">7*24智能法律专家</div>
          <div class="product-enter" @click="onGotoProduct('ai')">免费体验</div>
        </div>
        <div class="product-item">
          <img src="~/assets/images/about/experience/data.png" alt="" class="picture" />
          <div class="product-name">得理法搜</div>
          <div class="product-intro">法律难题 就找得理法搜</div>
          <div class="product-enter" @click="onGotoProduct('data')">免费体验</div>
        </div>
        <div class="product-item">
          <img src="~/assets/images/about/experience/dls.png" alt="" class="picture" />
          <div class="product-name">得理律助</div>
          <div class="product-intro">专为律师打造的智能助手</div>
          <div class="product-enter" @click="onGotoProduct('dls')">免费体验</div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="less" scoped>
  .container {
    width: 100%;

    .tip {
      position: relative;

      &::after {
        position: absolute;
        bottom: -7px;
        left: 50%;
        width: 32px;
        height: 6px;
        content: "";
        background: #4285f4;
        transform: translateX(-16px);
      }
    }

    .banner {
      width: 100%;
      height: 1017px;
      overflow: hidden;
      background-image: url("~/assets/images/about/banner.png");
      background-repeat: no-repeat;
      background-position: center;
      background-size: cover;

      .title-wrap {
        width: fit-content;
        height: fit-content;
        margin: 300px auto 0;
        overflow: hidden;
        text-align: center;

        h1 {
          @apply ~'tw-text-[30px] tw-leading-[66px]' mi:tw-text-[30px] mi:tw-leading-[66px] sm:tw-text-[56px] sm:tw-leading-[66px] md:tw-text-[86px] md:tw-leading-[121px];

          margin-top: 28px;
          font-weight: 600;
          color: #fff;
        }

        h3 {
          @apply ~'tw-text-[20px]' mi:tw-text-[20px] sm:tw-text-[36px] md:tw-text-[36px];

          color: #fff;
        }
      }
    }

    .introduction {
      @apply mi:tw-p-[20px] sm:tw-px-[50px] sm:tw-py-[130px] 2xl:tw-px-[150px] 2xl:tw-py-[170px];

      width: 100%;
      overflow: hidden;
      background-image: url("~/assets/images/about/introduction/bg.png");
      background-size: cover;

      .content {
        @apply ~ ' tw-p-[80px]' mi:tw-px-[40px] sm:tw-px-[80px] xl:tw-p-[170px] xl:tw-pt-[80px];

        margin: 0 auto;
        background: #fff;
        border-radius: 24px;
        box-shadow: 0 8px 36px 0 rgba(44, 60, 180, 15%);

        .box {
          @apply tw-flex tw-flex-col tw-items-center md:tw-flex-row md:tw-justify-between md:tw-space-x-[72px];
        }

        h1 {
          @apply ~'tw-mt-[56px] tw-text-[40px]';

          position: relative;
          font-weight: 600;
          line-height: 47px;
          color: #333;
          text-align: center;
        }

        img {
          @apply ~'tw-wh-[240px_96px] tw-mt-[70px]' xl:tw-wh-[534px_212px];
        }

        .text {
          h2 {
            @apply ~'tw-text-center tw-text-[32px]' md:tw-text-left;

            margin-top: 72px;
            margin-bottom: 16px;
            font-size: 36px;
            font-weight: 600;
            line-height: 50px;
            color: #1d2129;
          }

          p {
            margin-bottom: 0;
            font-size: 24px;
            font-weight: 400;
            line-height: 40px;
            color: #5a5d66;
          }
        }
      }
    }

    .founder {
      @apply mi:tw-py-[130px] lg:tw-pt-[96px];

      .box {
        @apply ~'tw-mt-[70px]' tw-flex tw-flex-wrap tw-justify-center mi:tw-space-y-[102px] mi:tw-px-[180px] sm:tw-justify-center md:tw-px-[200px] lg:tw-space-x-[100px] lg:tw-space-y-0 lg:tw-px-[0];

        .founder-item {
          @apply ~'tw-w-[388px]' mi:tw-w-[194px] sm:tw-w-[388px] lg:tw-w-[291px] xl:tw-w-[388px];

          img {
            @apply ~'tw-wh-[194px_212px]' mi:tw-wh-[194px_212px] sm:tw-wh-[388px_424px] lg:tw-wh-[291px_318px] xl:tw-wh-[388px_424px];
          }

          .title {
            margin-top: 40px;
            font-weight: 600;
            color: #333;
          }

          .name {
            @apply ~'tw-text-[36px]' mi:tw-text-[24px] md:tw-text-[36px] lg:tw-text-[30px] xl:tw-text-[36px];
          }

          .profession {
            @apply ~'tw-text-[24px]' mi:tw-text-[18px] md:tw-text-[24px] lg:tw-text-[20px] xl:tw-text-[24px];
          }

          .info {
            margin-top: 24px;
          }

          .intro {
            @apply ~'tw-text-[24px]';
          }
        }
      }
    }

    .honor {
      @apply mi:tw-py-[130px] sm:tw-py-[130px] md:tw-py-[148px];

      position: relative;
      width: 100%;
      background-image: url("~/assets/images/about/honorary-certificate/bg.png");
      background-size: cover;

      h1 {
        margin-bottom: 44px;
        font-size: 40px;
        font-weight: 600;
        line-height: 68px;
        color: #1d2129;
        text-align: center;
      }

      h3 {
        @apply ~'' mi:tw-px-[77px] sm:tw-px-[77px] lg:tw-px-[200px] xl:tw-px-[386px];

        margin-bottom: 80px;
        font-size: 24px;
        font-weight: 400;
        line-height: 34px;
        color: #4e5969;

        span {
          font-size: 32px;
        }
      }

      .carousel {
        @apply tw-hidden sm:tw-hidden md:tw-block md:tw-w-[calc(100%-100px)] lg:tw-w-[100%] xl:tw-w-[1368px];

        margin: 0 auto;

        .ant-carousel {
          .patent-certificate,
          .honorary-certificate,
          .member-unit {
            @apply md:tw-h-[113.3px] md:tw-w-[0] lg:tw-h-[170px] lg:tw-w-[100%] xl:tw-w-[1368px];

            .img-wrap {
              display: flex;
              align-items: center;
              justify-content: space-around;

              .img-item {
                position: relative;
                cursor: pointer;

                &::after {
                  position: absolute;
                  top: 0;
                  left: 0;
                  display: block;
                  width: 0;
                  height: 170px;
                  content: "";
                  background-color: rgba(0, 0, 0, 50%);
                }
              }
            }
          }

          .patent-certificate {
            .img-item {
              img {
                @apply ~' tw-wh-[124px_170px]' md:tw-wh-[82.7px_113.3px] lg:tw-wh-[124px_170px];
              }

              &:hover::after {
                @apply ~' tw-wh-[124px_170px]' md:tw-wh-[82.7px_113.3px] lg:tw-wh-[124px_170px];
              }
            }
          }

          .honorary-certificate {
            .img-item {
              img {
                @apply ~'tw-wh-[124px_170px]' md:tw-wh-[82.7px_113.3px] lg:tw-wh-[124px_170px];
              }

              &:hover::after {
                @apply ~' tw-wh-[124px_170px]' md:tw-wh-[82.7px_113.3px] lg:tw-wh-[124px_170px];
              }
            }
          }

          .member-unit {
            .img-item {
              img {
                @apply ~' tw-wh-[260px_170px]' md:tw-wh-[173.3px_113.3px] lg:tw-wh-[260px_170px];
              }

              &:hover::after {
                @apply ~' tw-wh-[260px_170px]' md:tw-wh-[173.3px_113.3px] lg:tw-wh-[260px_170px];
              }
            }
          }

          .prev-arrow,
          .next-arrow {
            @apply !tw-hidden md:!tw-flex lg:!tw-hidden xl:!tw-flex;

            top: 10px;
            // display: flex !important;
            align-items: center;
            justify-content: center;
            width: 42px;
            height: 100%;
            background: #fff;
            border: 1px solid #b9c5d2;

            .arrow {
              font-size: 23px;
              color: #4e5969;
            }

            &:hover {
              background-color: #2f78ff;

              .arrow {
                color: #fff;
              }
            }
          }

          .prev-arrow {
            left: -42px;
          }

          .next-arrow {
            right: -42px;
          }
        }
      }

      .picture-list {
        @apply ~'tw-gap-[48px] tw-justify-between' tw-flex tw-flex-wrap mi:tw-mx-auto mi:tw-w-[360px] mi:tw-gap-[30px] mi:tw-px-[20px] sm:tw-mx-auto sm:tw-w-[500px] md:tw-hidden;

        img {
          @apply ~' tw-wh-[124px_170px]' mi:tw-wh-[82.7px_113.3px] sm:tw-wh-[124px_170px];
        }
      }
    }

    .develop-history {
      img {
        width: 100%;
        height: auto;
      }
    }

    .origin {
      @apply ~'tw-py-[130px]' md:tw-py-[150px];

      width: 100%;
      background: #f5f9ff;

      @media (max-width: 800px) {
        .box1 {
          display: none;

          .row {
            height: 130px;
          }

          .img {
            height: 130px;
          }

          .text {
            width: 200px;
          }
        }

        .box2 {
          display: block;

          .item {
            img {
              height: 260px;
            }
          }

          .text {
            position: relative;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            width: 400px;
            height: 260px;

            .icon-wrap {
              display: flex;
              align-items: center;
              justify-content: center;
              width: 96px;
              height: 96px;
              margin-bottom: 12px;
              background: #f5f9ff;
              border-radius: 96px;

              .anticon {
                font-size: 54px;
              }
            }

            .desc {
              font-size: 20px;
              font-weight: 500;
              line-height: 34px;
              color: #4e5969;
            }
          }

          .one {
            background: #2f78ff;

            .desc {
              color: #fff;
            }
          }

          .three,
          .five {
            background: #fff;
          }

          .one,
          .three,
          .five {
            &::after {
              position: absolute;
              bottom: -13px;
              display: inline-block;
              width: 26px;
              height: 26px;
              content: "";
              background-color: #2f78ff;
              transform: rotate(-45deg);
            }
          }

          .three::after {
            background-color: #fff;
          }

          .five::after {
            top: -13px;
            bottom: none;
            background-color: #fff;
          }
        }
      }

      @media (min-width: 800px) {
        .row {
          height: 195px;
        }

        .item {
          img {
            height: 195px;
          }
        }

        .text {
          width: 300px;
        }
      }

      h1 {
        margin-bottom: 60px;
        font-size: 40px;
        font-weight: 600;
        line-height: 68px;
        color: #1d2129;
        text-align: center;
      }

      h4 {
        margin-bottom: 60px;
        font-size: 24px;
        font-weight: 400;
        line-height: 34px;
        color: #4e5969;
        text-align: center;

        &:nth-of-type(1) {
          margin-bottom: 0;
        }
      }

      .content {
        width: fit-content;
        // height: 520px;
        margin: 0 auto;

        .row {
          // height: 260px;
          @apply ~' tw-h-[260px]' md:tw-h-[195px] lg:tw-h-[195px] xl:tw-h-[260px];

          display: flex;

          .item {
            flex: 1;

            img {
              // height: 260px;
              @apply ~' tw-h-[260px]' md:tw-h-[195px] lg:tw-h-[195px] xl:tw-h-[260px];
            }
          }

          .text {
            // width: 400px;
            @apply ~' tw-w-[400px]' md:tw-w-[300px] lg:tw-w-[300px] xl:tw-w-[400px];

            position: relative;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;

            .icon-wrap {
              display: flex;
              align-items: center;
              justify-content: center;
              width: 96px;
              height: 96px;
              margin-bottom: 12px;
              background: #f5f9ff;
              border-radius: 96px;

              .anticon {
                font-size: 54px;
              }
            }

            .desc {
              font-size: 20px;
              font-weight: 500;
              line-height: 34px;
              color: #4e5969;
            }
          }

          .one {
            background: #2f78ff;

            .desc {
              color: #fff;
            }
          }

          .three,
          .five {
            background: #fff;
          }

          .one,
          .three,
          .five {
            &::after {
              position: absolute;
              bottom: -13px;
              display: inline-block;
              width: 26px;
              height: 26px;
              content: "";
              background-color: #2f78ff;
              transform: rotate(-45deg);
            }
          }

          .three::after {
            background-color: #fff;
          }

          .five::after {
            top: -13px;
            bottom: none;
            background-color: #fff;
          }
        }
      }

      .box2 {
        .item {
          img {
            @apply ~'' mi:tw-h-[195px] sm:tw-h-[260px];
          }
        }

        .text {
          @apply ~'' mi:tw-wh-[300px_195px] sm:tw-wh-[400px_260px];
        }
      }
    }

    .map {
      @apply ~'tw-py-[130px]' sm:tw-py-[174px];

      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      background-image: url("~/assets/images/about/map-bg.png");
      background-repeat: no-repeat;
      background-size: cover;

      .address {
        @apply ~'tw-gap-x-[126px] tw-gap-y-[32px]' tw-justify-center;

        display: flex;
        flex-wrap: wrap;
        align-items: center;
        padding: 0 40px;

        &-left {
          width: fit-content;

          h1 {
            position: relative;
            margin-bottom: 84px;
            font-size: 36px;
            font-weight: 600;
            line-height: 68px;
            color: #1d2129;

            &::after {
              position: absolute;
              bottom: -7px;
              left: 0;
              width: 32px;
              height: 6px;
              content: "";
              background: #3555fe;
            }
          }

          h3 {
            margin-bottom: 24px;
            font-size: 24px;
            font-weight: 600;
            line-height: 34px;
            color: #1d2129;
          }

          .item {
            margin-bottom: 24px;

            h4 {
              margin-bottom: 4px;
              font-size: 20px;
              font-weight: 600;
              line-height: 34px;
              color: #1d2129;
            }

            p {
              .anticon {
                margin-right: 5px;
                font-size: 24px;
              }

              span {
                font-size: 16px;
                font-weight: 400;
                line-height: 34px;
                color: #4e5969;
              }
            }

            &:last-child {
              margin-bottom: 0;
            }
          }
        }

        &-right {
          @apply ~' tw-wh-[100%_400px]' sm:tw-wh-[676px_400px];
        }
      }
    }

    .experience {
      @apply ~"tw-bg-[url('~/assets/images/about/experience/minibg.png')]" lg:tw-bg-[url('~/assets/images/about/experience/bg.png')];

      width: 100%;
      // background-image: url("~/assets/images/about/experience/minibg.png");
      background-size: cover;

      .list {
        @apply ~'tw-w-[320px] tw-gap-y-[120px]' tw-mx-auto tw-flex tw-flex-wrap tw-items-center tw-justify-center md:tw-w-full md:tw-justify-around;
        @apply ~'tw-py-[72px]';

        .product-item {
          @apply ~'tw-text-white tw-flex-col' tw-flex tw-items-center;

          .picture {
            @apply ~"tw-mb-[16px] tw-wh-[90px]" md:tw-hidden;
          }

          .product-name {
            @apply ~'tw-mb-[18px] tw-text-[32px]' tw-font-bold;
          }

          .product-intro {
            @apply ~'tw-mb-[24px] tw-text-[24px]' md:tw-mb-[38px];
          }

          .product-enter {
            @apply ~ 'tw-h-[46px] tw-leading-[46px]' tw-cursor-pointer tw-bg-white tw-text-[#2A3ACC];
            @apply ~'tw-px-[27px] tw-rounded-[24px]';
            @apply ~'tw-text-[20px] tw-text-center';

            &:hover {
              background-color: rgb(242, 243, 245);
            }

            &:active {
              background-color: rgb(201, 205, 212);
            }
          }
        }
      }
    }

    :deep(.ant-tooltip) {
      max-width: none;

      .ant-tooltip-arrow::before {
        background-color: transparent;
      }

      .ant-tooltip-inner {
        padding: 0;
        background-color: transparent;

        .img-enlarge {
          p {
            width: fit-content;
            height: 28px;
            padding: 0 4px;
            margin-bottom: 0;
            font-size: 14px;
            font-weight: 400;
            line-height: 28px;
            color: #fff;
            background: #494949;
          }

          img {
            height: 408px;
            padding: 8px;
            background-color: #fff;
            border: 1px solid #dfdfe0;
            box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 11%);
          }
        }
      }
    }
  }

  :deep(.BMapLabel) {
    position: absolute;
    top: 50% !important;
    left: 50% !important;
    z-index: 0;
    display: inline;
    padding: 22px !important;
    font:
      14px arial,
      sans-serif;
    font-size: 16px !important;
    color: #283548 !important;
    white-space: nowrap;
    cursor: inherit;
    user-select: none;
    background: #f9fbff !important;
    border: 1px solid transparent !important;
    border-radius: 8px;
    box-shadow: 4px 8px 8px 0 rgba(126, 153, 191, 40%);
    transform: translate(-47%, -120%);

    &::after {
      position: absolute;
      bottom: -8px;
      left: 50%;
      content: "";
      border: 10px solid transparent;
      border-top: 8px solid #fff;
      border-bottom: 0;
      transform: translateX(-50%);
    }
  }

  .map-label-container {
    position: relative;
  }

  .map-label {
    position: relative;
    z-index: 1;
  }

  .map-label-arrow {
    position: absolute;
    bottom: -8px;
    left: 50%;
    z-index: 0;
    width: 0;
    height: 0;
    border-color: #f9fbff transparent transparent;
    border-style: solid;
    border-width: 8px 8px 0;
    transform: translateX(-50%);
  }

  :deep(.custom-label::after) {
    position: absolute;
    bottom: -8px;
    left: 50%;
    z-index: 0;
    width: 0;
    height: 0;
    content: "";
    border-color: #f9fbff transparent transparent;
    border-style: solid;
    border-width: 8px 8px 0;
    transform: translateX(-50%);
  }

  /* 去掉百度地图logo--begin */

  /* :deep(.BMap_cpyCtrl) {
    display: none;
  }

  :deep(.anchorBL) {
    display: none;
  } */

  /* 去掉百度地图logo--end */
</style>
